export default __webpack_public_path__ + "static/media/GreenOfficeCampBg.e1392988.png";